import { Component } from '@angular/core';

@Component({
    selector: 'via-sku-time-series',
    templateUrl: './sku-time-series.component.html',
    styleUrls: ['./sku-time-series.component.scss'],
})
export class SkuTimeSeriesComponent {
    public isShowingAllPrices: boolean;

    public showRegularPrice: boolean;

    public updateDisplayedPrice(event: boolean): void {
        this.showRegularPrice = event;
    }

    public updateShowAllPrices(event: boolean): void {
        this.isShowingAllPrices = event;
    }
}
